import { getUserData } from "@/auth/getUserData";

export default {
    namespaced: true,
    state: {
        status: getUserData()?.status ?? "offline",
    },
    getters: {},
    mutations: {
        UPDATE_STATUS(state, status) {
            if (!status) {
                return;
            }

            state.status = status;

            const userData = getUserData();
            userData.status = status;

            localStorage.setItem("userData", JSON.stringify(userData));
        },
    },
};
